import { useATMStore } from '../store/atmStore'
import { darkTheme, lightTheme, type AppTheme } from '../theme'

/**
 * Returns the current design-token palette (dark or light).
 * Usage inside any component:
 *   const C = useTheme()
 */
export function useTheme(): AppTheme {
  const theme = useATMStore((s) => s.theme)
  return theme === 'dark' ? darkTheme : lightTheme
}
